import { baseMenuItems } from "./menuBase";
import { adminMenuItems } from "./menuAdmin.";
import { MENU_VISIBILITY_BY_COUNTRY } from "./menuByCountry";
import { COUNTRY_CODES } from "../../constants/countries";
import { ItemType } from "antd/es/menu/interface";

const filterMenu = (items: ItemType[], hiddenKeys: any[] = []) => {
  return items
    .filter((item) => !hiddenKeys.includes(item!.key))
    .map((item: any) => {
      if (item!.children) {
        return {
          ...item,
          children: item!.children.filter(
            (child: any) => !hiddenKeys.includes(child.key),
          ),
        };
      }
      return item;
    });
};

export const getMenuItems = ({ isAdmin, country }: any) => {
  const countryRules =
    MENU_VISIBILITY_BY_COUNTRY[country?.code] ||
    MENU_VISIBILITY_BY_COUNTRY[(COUNTRY_CODES as any).ECUADOR];

  let items = [];

  if (isAdmin) {
    items = [...baseMenuItems, ...adminMenuItems].sort((a, b) =>
      a!.key!.toString().localeCompare(b!.key!.toString(), undefined, {
        numeric: true,
        sensitivity: "base",
      }),
    );
  } else {
    items = baseMenuItems;
  }

  if (countryRules.hide) {
    items = filterMenu(items, countryRules.hide);
  }

  return items;
};
